export default "__VITE_ASSET__9U6_NBCb__"